import { Breakpoints } from "@civicplus/preamble-ui/lib/Utilities/ThemeHelper";
import React, { ReactNode, useEffect } from "react";
import { ProductThemeProvider as PreambleProductThemeProvider } from "@civicplus/preamble-ui/lib/ProductThemeProvider";
import { AppDispatch, RootState } from "../../app/store";
import { useSelector, useDispatch } from "react-redux";
import { getPortalCustomizationAsync } from "../../actions";
import { SnackbarProvider, MaterialDesignContent } from "notistack";
import { darken, styled } from "@mui/material";
interface ProductThemeProviderProps {
  children: ReactNode;
  prefix?: string;
}
export const snackbarContainerId = "clerk-snackbar-container";

export const ProductThemeProvider: React.FC<ProductThemeProviderProps> = ({
  children,
  prefix,
}) => {
  const maxBreakpoint = window.clerkEmbedProps?.maxBreakpoint;
  const breakpointOverride = window.clerkEmbedProps?.breakpoints;
  const themeOverride = {
    breakpoints: {
      values: breakpointOverride,
    } as Breakpoints,
  };

  const dispatch = useDispatch<AppDispatch>();
  const portalCustomization = useSelector(
    (state: RootState) => state.portalCustomization
  );
  const themeColor =
    window.clerkEmbedProps?.color ||
    portalCustomization?.publicPortalCustomColor ||
    "#b3b3b3";
  const StyledMaterialDesignContent = styled(MaterialDesignContent)(() => ({
    "&.notistack-MuiContent-info": {
      backgroundColor: darken(themeColor, 0.3),
    },
  }));

  // Workaround to allow Snackbars to be visible from a Dialog
  useEffect(() => {
    if (portalCustomization == null) {
      getPortalCustomizationAsync()(dispatch);
    }
  }, [dispatch, portalCustomization]);

  if (!portalCustomization) return null;

  return (
    <PreambleProductThemeProvider
      product="clerk"
      primaryHex={themeColor}
      cssReset={Boolean(process.env.REACT_APP_EMBED)}
      specificity={process.env.REACT_APP_EMBED ? 3 : undefined}
      prefix={prefix}
      themeOverride={breakpointOverride ? themeOverride : undefined}
      maxBreakpoint={maxBreakpoint ? maxBreakpoint : undefined}
    >
      <SnackbarProvider
        hideIconVariant={true}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        Components={{
          success: StyledMaterialDesignContent,
          error: StyledMaterialDesignContent,
          info: StyledMaterialDesignContent,
        }}
      >
        {children}
      </SnackbarProvider>
    </PreambleProductThemeProvider>
  );
};

export default ProductThemeProvider;
